<template>
  <span :class="classes">
    <span :class="`${computedClasses} no-margin`">
      <slot />
    </span>
  </span>
</template>

<script>
const variantClasses = {
  body: 'body-font-size',
  h5: 'h4',
  h4: 'h3',
  h3: 'h2',
  h2: 'h1'
};

export default {
  name: 'TrTypography',
  props: ['variant', 'classes', 'fixedLinesQtd', 'strong',
    'breakAllWords', 'color'],
  computed: {
    computedClasses: function() {
      let computedClasses = variantClasses[this.variant] || variantClasses.body;
      if (this.fixedLinesQtd) {
        computedClasses += ` have-${this.fixedLinesQtd}-fixed-size-lines block `;
      }
      if (this.color) {
        computedClasses += ` ${this.color} `;
      }
      if (this.breakAllWords) {
        computedClasses += ' break-all-words ';
      }
      if (this.strong) {
        computedClasses += ' strong ';
      }
      return computedClasses;
    }
  }
}
</script>